import { fieldTypes } from '@constants/constant';
import { REGEX } from '@core/validation';
import { BucketFolders } from '@enums/application.enums';
import { Fields } from '@modules/dynamic-form-builder/model/formBuilderInterface';
import { CommonService } from '@modules/shared/services/common.service';
import { COVER_PAGE_IMAGE_FILE_PREFIX } from '@modules/whitelabel-cover-page/whitelabel-cover-page.constants';

const COVER_PAGE_IMAGE_FIELD_TYPES = new Set<fieldTypes>([
  fieldTypes.BANNER_IMAGE,
  fieldTypes.MULTIPLE_IMAGE,
  fieldTypes.VIDEO_UPLOAD
]);

/** White-label site owner from WL config (works for guest + authenticated). */
export function resolveCoverPageCreatorGsi4pk(
  commonService: CommonService
): string | null {
  const gsi4pk =
    commonService.getWhiteLabelProperty('user.gsi4pk') ||
    commonService.getWhiteLabelConfiguration()?.user?.gsi4pk ||
    commonService.getLoggedInUser()?.gsi4pk;
  return typeof gsi4pk === 'string' && gsi4pk.trim() ? gsi4pk.trim() : null;
}

export function buildCoverPageImageUploadFolder(gsi4pk: string): string {
  return `${BucketFolders.coverPageFolder}${gsi4pk}/`;
}

export function getCoverPageUploadFolderOrNull(
  commonService: CommonService
): string | null {
  const gsi4pk = resolveCoverPageCreatorGsi4pk(commonService);
  return gsi4pk ? buildCoverPageImageUploadFolder(gsi4pk) : null;
}

export function buildCoverPageImageFileName(originalName: string): string {
  const sanitized = originalName
    .toLowerCase()
    .replace(REGEX.IMAGE_UPLOAD_TO_S3_NAME, '_')
    .split(' ')
    .join('_');
  return `${COVER_PAGE_IMAGE_FILE_PREFIX}${Date.now()}_${sanitized}`;
}

export function applyCoverPageUploadFolderToFields(
  fields: Fields | null,
  folder: string
): void {
  if (!fields?.sections) {
    return;
  }
  for (const section of fields.sections) {
    for (const field of section.fields ?? []) {
      if (field.type && COVER_PAGE_IMAGE_FIELD_TYPES.has(field.type)) {
        field.uploadFolder = folder;
      }
    }
  }
}

export function formValueHasUnsafeLocalMediaUrls(value: unknown): boolean {
  if (typeof value === 'string') {
    return value.startsWith('blob:') || value.startsWith('data:');
  }
  if (Array.isArray(value)) {
    return value.some(formValueHasUnsafeLocalMediaUrls);
  }
  if (value && typeof value === 'object') {
    return Object.values(value as Record<string, unknown>).some(
      formValueHasUnsafeLocalMediaUrls
    );
  }
  return false;
}
